import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CalendarFormComponent} from "./form/calendar-form.component";
import {CalendarComponent} from "./calendar.component";

const routes: Routes = [
  {
    path: '',
    component: CalendarComponent
  },
  {
    path: 'v',
    children: [{
      path: '**',
      component: CalendarComponent
    }]
  },
  {
    path: 'event',
    children: [
      {
        path: ':id',
        component: CalendarFormComponent
      },
      {
        path: '**',
        redirectTo: 'create',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'create',
    children: [
      {
        path: ':data',
        component: CalendarFormComponent
      },
      {
        path: '**',
        component: CalendarFormComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalendarRoutingModule {
}
